import type { ThemeConfig } from 'antd';

const config: ThemeConfig = {
  token: {
    lineWidth: 1,
    controlHeight: 37,
    fontSize: 15,
  },
  components: {
    Tag: {
      defaultColor: '#3a3f43',
    },
    Form: {
      itemMarginBottom: 12,
    },
    Layout: {
      headerHeight: 60,
    },
  },
};

export default config;
